import React from 'react';
import { styled } from 'styled-components';
import ArrowDown from '../icons/angle-down-solid.svg';
import { Icon } from '../icon';
import { useState } from 'react';

export const PropertiesPanelAccordionContainer = styled.div`
    font-family: ${(props) => props.theme.app.font};
`;

export const PropertiesPanelAccordionHeader = styled.div`
    cursor: pointer;
    font-size: 15px;
    font-weight: bold;
    display: flex;
    gap: 10px;
    align-items: center;
    display: flex;
    border-bottom: 1px solid ${(props) => props.theme.app.borderColor};
    padding: 10px 0px;

    ${Icon} {
        margin-left: auto;
        color: #445a64;
    }
`;

export const PropertiesPanelAccordionContent = styled.div<{ $isOpen: boolean }>`
    max-height: ${(props) => (props.$isOpen ? '3000px' : '0')};
    transition: max-height 300ms;
    overflow: hidden;
`;

export const PropertiesPanelAccordion = (props: { defaultIsOpen?: boolean; header: React.ReactNode; children: React.ReactNode }) => {
    const [isOpen, setIsOpen] = useState(props.defaultIsOpen ?? true);

    return (
        <PropertiesPanelAccordionContainer>
            <PropertiesPanelAccordionHeader onClick={() => setIsOpen((prev) => !prev)}>
                {props.header}
                <Icon>
                    <ArrowDown />
                </Icon>
            </PropertiesPanelAccordionHeader>
            <PropertiesPanelAccordionContent $isOpen={isOpen}>{props.children}</PropertiesPanelAccordionContent>
        </PropertiesPanelAccordionContainer>
    );
};
